import styles from "./styles.module.scss";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { ProgressBar, RoutedModal } from "../../../common";
import primaryComponents from "../../../primaryComponents";
import { ExclamationTriangle, EyeIcon } from "../../../../assets/svgIcons";
import { useSmsCampaignReviewForm } from "./useSmsCampaignReviewForm";
import { pathConstants } from "../../../../routes/pathContants";
import ToolTipV2 from "../../ToolTipV2";
import { TotalRecipients } from "../TotalRecipients";

export const SmsCampaignReviewForm = ({ smsCampaign = {} }) => {
  const {
    isLoading,
    isRecipient,
    setisRecipient,
    handleActivateCampaign,
    navigate,
  } = useSmsCampaignReviewForm();

  const progressPercent =
    10 >= smsCampaign?.estimated_first_run_cost
      ? 100
      : smsCampaign?.wallet_balance <= 0
        ? 0
        : (smsCampaign?.estimated_first_run_cost /
            smsCampaign?.wallet_balance) *
          100;

  return (
    <>
      <section className={`${globalStyles.pageColumnGaps}`}>
        <div>
          <h5>Review & Send</h5>
          <p>
            Review your campaign details and check your credit balance before
            sending
          </p>
        </div>

        <div className={styles.content}>
          <div className={styles.metricsCover}>
            <div
              className={`${globalStyles.cardWithBackground} ${styles.metricsCover__card}`}
            >
              <p className="d-flex align-items-center">
                <span>Total Recipients</span>
                <ToolTipV2 tipText="View Recipients">
                  <span
                    className="ml-3 cursor-pointer"
                    onClick={() => setisRecipient(true)}
                  >
                    <EyeIcon stroke="#7647ee" size={20} />
                  </span>
                </ToolTipV2>
              </p>
              <h5>{smsCampaign?.recipient_count_estimate}</h5>
            </div>

            <div
              className={`${globalStyles.cardWithBackground} ${styles.metricsCover__card}`}
            >
              <p>Cost Per SMS</p>
              <h5>
                {smsCampaign?.sms_unit_cost}{" "}
                <span className="small-text-size gray--text font-weight-normal">
                  credits
                </span>
              </h5>
            </div>

            <div
              className={`${globalStyles.cardWithBackground} ${styles.metricsCover__card} ${styles.purple}`}
            >
              <p>Total Campaign Cost</p>
              <h5>
                {smsCampaign?.estimated_first_run_cost}{" "}
                <span className="small-text-size gray--text font-weight-normal">
                  credits
                </span>
              </h5>
            </div>

            <div
              className={`${globalStyles.cardWithBackground} ${styles.metricsCover__card}`}
            >
              <p>Credit Wallet Balance</p>
              <h5>
                {smsCampaign?.wallet_balance}{" "}
                <span className="small-text-size gray--text font-weight-normal">
                  credits
                </span>
              </h5>

              <div className="mt-auto">
                <ProgressBar
                  progress={20}
                  progressColor={progressPercent >= 100 ? "#19ae57" : "#dc3545"}
                />
                <div className="d-flex justify-content-between">
                  <p className="smallest-text-size">
                    {smsCampaign?.wallet_balance} available
                  </p>

                  <p className="smallest-text-size">
                    {smsCampaign?.estimated_first_run_cost} needed
                  </p>
                </div>
              </div>
            </div>

            {smsCampaign?.wallet_balance -
              smsCampaign?.estimated_first_run_cost <
            0 ? (
              <div
                className={`${globalStyles.cardWithBackground}  ${styles.metricsCover__insufficient} p-0`}
              >
                <div className="text-center my-auto mx-3">
                  <ExclamationTriangle
                    className="error--text"
                    style={{ fontSize: "20px" }}
                  />
                  <h5 className="error--text">InSufficient Balance</h5>
                  <p className="error--text small-text-size">
                    You are short{" "}
                    <span className="font-weight-bold">
                      {smsCampaign?.estimated_first_run_cost -
                        smsCampaign?.wallet_balance}
                    </span>{" "}
                    for this campaign, please top up your wallet to proceed
                  </p>
                </div>

                <div className={styles.btn}>
                  <primaryComponents.Button
                    classNames={"btn btn--primary mx-auto"}
                    onClick={() =>
                      navigate(pathConstants.SETTINGS_PLATFORM_CREDIT_TOPUP)
                    }
                  >
                    Top Up Credits
                  </primaryComponents.Button>
                </div>
              </div>
            ) : null}
          </div>

          <div className={styles.preview}>
            <h5>Message Preview</h5>

            <div className="mt-4 text-center">
              <div>
                <p>
                  Sender ID:{" "}
                  <span className="dark--text">
                    {smsCampaign?.sender?.sender_id}
                  </span>
                </p>
              </div>
            </div>

            <div
              className={`${globalStyles.cardWithBorder} white p-3 mt-3`}
              style={{ minHeight: "150px" }}
            >
              <p>{smsCampaign?.message_body}</p>
            </div>
          </div>
        </div>

        <primaryComponents.Button
          className={"mt-4 ml-auto btn btn--primary"}
          isDisabled={
            isLoading ||
            smsCampaign?.wallet_balance -
              smsCampaign?.estimated_first_run_cost <
              0
          }
          isLoading={isLoading}
          loadingText={"Activating..."}
          onClick={() => handleActivateCampaign()}
        >
          Activate Campaign
        </primaryComponents.Button>
      </section>

      <RoutedModal
        isActive={isRecipient}
        width={"700px"}
        headerTitle="Recipients"
        closeModal={() => setisRecipient(false)}
      >
        <TotalRecipients smsCampaign={smsCampaign} />
      </RoutedModal>
    </>
  );
};
